import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=ed558de2&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=ed558de2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed558de2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed558de2')) {
      api.createRecord('ed558de2', component.options)
    } else {
      api.reload('ed558de2', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=ed558de2&scoped=true", function () {
      api.rerender('ed558de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Header.vue"
export default component.exports